import { QueryClient } from '@tanstack/react-query'

const TANSTACK_MUTATION_MAX_RETRIES = 0
const TANSTACK_QUERY_GC_TIME_MS = 1000 * 60 * 10 // 10 minutes (formerly cacheTime)
const TANSTACK_QUERY_STALE_TIME_MS = 1000 * 60 * 5 // 5 minutes
const TANSTACK_QUERY_MAX_RETRIES = 2

export function queryClient({
	disableRetry,
}: Readonly<{ disableRetry: boolean }>) {
	return new QueryClient({
		defaultOptions: {
			mutations: {
				retry: (failureCount) => {
					if (disableRetry) {
						return false
					}
					return failureCount <= TANSTACK_MUTATION_MAX_RETRIES
				},
			},
			queries: {
				gcTime: TANSTACK_QUERY_GC_TIME_MS,
				refetchOnWindowFocus: false,
				retry: (failureCount, error) => {
					if (disableRetry) {
						return false
					}
					if (failureCount > TANSTACK_QUERY_MAX_RETRIES) {
						return false
					}
					if (error?.status && error?.status >= 400 && error?.status < 500) {
						return false
					}
					return true
				},
				staleTime: TANSTACK_QUERY_STALE_TIME_MS,
			},
		},
	})
}
